import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import { Divider } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import ListDetail from "./ListDetail";
import AlertChip from "../AlertChip";
//searchBar related import
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';

import moment from 'moment';

import {styles} from '../CSS/RoutineStyles.js';

import config from "../../config/config";
import setting from "../../config/setting";
import axios from 'axios';

import CustomizedTable from "../CSSComponent/table"

let counter = 0;
function createData(alertId, entity, creator, PO1, PO2, status, date) {
    counter += 1;
    return { alertId, entity, creator, PO1, PO2, status, date };
}

function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const toolbarStyles = theme => ({
    root: {
        paddingRight: theme.spacing.unit,
        height: 'flex'
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    spacer: {
        flex: '1 1 100%',
    },
    actions: {
        color: theme.palette.text.secondary,
    },
    title: {
        flex: '0 0 auto',
    },
});

class EnhancedTableToolbar extends React.Component {
    constructor(props) {
        super(props);
        this.getDescriptions = this.getDescriptions.bind(this);
        this.state = {
            typename:null,
            routine: "",
            description: "",
            num_high_risk_alerts: "",
            num_medium_risk_alerts: "",
            num_low_risk_alerts: ""
        };
    }
    componentWillMount() {
        let pathtypename = this.props.type;
        this.setState({ typename: pathtypename });
    }
    componentDidMount() {
        this.getDescriptions();
    }
    componentDidUpdate(prevProps){
        //console.log(this.props.type +"  "+ prevProps.type)
        if (this.props.type !== prevProps.type) {
            this.getDescriptions();
        }
        
    }

    getDescriptions() {
        //console.log("------------------------------------------now the routine name is "+this.state.typename+this.props.type)
        if(this.state.typename == null){
            this.setState({
                    routine: "",
                    description: "",
                    num_high_risk_alerts: "",
                    num_medium_risk_alerts: "",
                    num_low_risk_alerts: ""
                });
        }else{
        axios.get(config.alerts, {
            params:{'routine':this.props.type}
        }).then(
            res => {
                //console.log("num of high risks in BE " + res.data.num_high_risk_alerts)
                this.setState({
                    routine: res.data.routine,
                    description: res.data.description,
                    num_high_risk_alerts: res.data.num_high_risk_alerts,
                    num_medium_risk_alerts: res.data.num_medium_risk_alerts,
                    num_low_risk_alerts: res.data.num_low_risk_alerts
                });
            });
        }
    }
    render() {
        const { numSelected, classes } = this.props;
        //console.log("num of high risks " + this.state.num_high_risk_alerts)
        return (
            <Toolbar
                className={classNames(classes.root, {
                    [classes.highlight]: numSelected > 0,
                })}
            >
                <div className={classes.title}>
                    {numSelected > 0 ? (
                        <Typography color="inherit" variant="subheading">
                            {numSelected} selected
                        </Typography>
                    ) : (
                        <div style={{   textAlign: "left", marginTop: "1vh", marginBottom: "1vh" }}>
                            <Typography variant="title" id="tableTitle">
                                {this.state.routine}
                            </Typography>
                            <div style={{ height: "1vh" }}></div>
                            <Typography id="tableTitle">
                                {this.state.description}
                            </Typography>
                            <div style={{ height: "1vh" }}></div>
                            <span>
                                {this.state.num_high_risk_alerts != 0 ? <Chip
                                    avatar={
                                        <Avatar style={{ background: "rgba(188,32,75,1)", color: "snow" }}>
                                            {this.state.num_high_risk_alerts}
                                        </Avatar>
                                    }
                                    label="high"
                                    style={{ border: "1px solid rgba(188,32,75,1)", marginRight: "1vh"}}
                                    variant="outlined"
                                /> : null}
                                {this.state.num_medium_risk_alerts != 0 ? <Chip
                                    avatar={
                                        <Avatar style={{ background: "rgba(246,141,46,1)", color: "snow" }}>
                                            {this.state.num_medium_risk_alerts}
                                        </Avatar>
                                    }
                                    label="mid"
                                    style={{ border: "1px solid rgba(246,141,46,1)", marginRight: "1vh" }}
                                    variant="outlined"
                                /> : null}
                                {this.state.num_low_risk_alerts != 0 ? <Chip
                                    avatar={
                                        <Avatar style={{ background: "rgba(67,176,42,1)", color: "snow" }}>
                                            {this.state.num_low_risk_alerts}
                                        </Avatar>
                                    }
                                    label="low"
                                    style={{ border: "1px solid rgba(67,176,42,1)" , marginRight: "1vh"}}
                                    variant="outlined"
                                /> : null}
                            </span>
                            <span></span>
                        </div>
                    )}
                </div>
                <div className={classes.spacer} />
                <div className={classes.actions}>
                    {numSelected > 0 ? (
                        <Button variant="outlined" size="small" onClick={this.handleViewToggle}>Action..</Button>
                    ) : (
                        <Tooltip title={this.props.details? "Hide Details":"Show Details"}>
                            <IconButton aria-label="Details" onClick={this.props.handleDetailViewToggle}>
                                {this.props.details? <ArrowRightIcon fontSize="large"/>:<ArrowLeftIcon fontSize="large"/>}
                            </IconButton>
                        </Tooltip>
                    )}
                </div>
            </Toolbar>
        );
    }
};

EnhancedTableToolbar.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);


class VendorAlertTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            updatedetailID:"",
            typename: null,
            open: true,
            anchor: 'right',
            order: 'asc',
            orderBy: 'id',
            details: true,
            list: 6,
            selected: [],
            data: [
            ],
            fields: [],
            page: 0,
            rowsPerPage: 10,
            selectedAlert: createData('ABC Pte Ltd', [{
                name: "Confict Interest",
                avatar: "CI",
                color: "primary"
            }, {
                name: "Duplicate Address",
                avatar: "DA",
                color: "primary",
            }, {
                name: "Duplicate PO",
                avatar: "DP",
                color: "secondary"
            }
            ], 3.7, 67, 4.3, {
                high: 1,
                mid: 2,
                low: 3
            }),
            details: true,
            filtered: [],
            width: 0,
            height: 0,
        };
        this.getAlerts = this.getAlerts.bind(this);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

    }
    componentWillMount() {
        let pathtypename = this.props.type;
        this.setState({typename: pathtypename}) 
    }
    componentWillUnmount(){
        window.removeEventListener('resize', this.updateWindowDimensions);
    }
    componentDidMount() {
        this.getAlerts();
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }
    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }
    componentDidUpdate(prevProps){
        if (this.props !== prevProps) {
            this.getAlerts();
            let pathtypename = this.props.type;
            this.setState({typename: pathtypename}) 
        }
    }
    getAlerts() {
        console.log('get alerts')
        console.log(this.props.type)
        axios.get(config.alerts, {
            params:{'routine':this.props.type},
        }).then(
            res => {
                console.log("update routine with new data");
                console.log(res.data.items);
                this.setState({
                    data: res.data.items,
                    filtered: res.data.items,
                    fields: res.data.table_def,
                    updatedetailID: res.data.items.length == 0 ? null : res.data.items.sort(getSorting(this.state.order, this.state.orderBy))[0]["id"]
                });
            }
        ).catch(error=>{console.log(error)})

        // axios({
        //     method: 'get',
        //     url: config.alerts.concat('?routine=',this.props.type),
        //     // headers: {
        //     //     Authorization: 'Basic ' + btoa('adminA'+':'+'kpmg@123'),
        //     // }
        //     auth: {
        //         username: 'adminA',
        //         password: 'kpmg@123',
        //     }
        // }).then(
        //     res => {
        //         // console.log("update routine with new data");
        //         // console.log(res.data.items);
        //         this.setState({
        //             data: res.data.items,
        //             filtered: res.data.items,
        //             fields: res.data.table_def,
        //             updatedetailID: res.data.items.length == 0 ? null : res.data.items.sort(getSorting(this.state.order, this.state.orderBy))[0]["id"]
        //         });
        //     }
        // )

        // let headers = new Headers();
        // headers.set('Authorization', 'Basic ' + btoa('adminA' + ":" + 'kpmg@123'));

        // fetch(config.alerts.concat('?routine=open invoice'),{
        //     method: 'GET',
        //     headers: headers,
        // }).then(function(res) {
        //     return res.json();
        //    }).then(function(resJson) {
        //     console.log(resJson);
        //     console.log('yes!');
        //    })
    }
    handleDetailViewToggle = () => {
        // console.log("in toggles")
        // console.log(this.state.details);
        this.setState({
            details:!this.state.details,
        });
    }
    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    handleSelectAllClick = (event, checked) => {
        if (checked) {
            this.setState(state => ({ selected: state.data.map(n => n.id) }));
            return;
        }
        this.setState({ selected: [] });
    };

    // handleClick = (event, id, alert) => {
    //     // console.log("clicked ID is "+id);
    //     const { selected } = this.state;
    //     const selectedIndex = selected.indexOf(id);
    //     this.setState({ selectedAlert: alert })
    //     let newSelected = [];

    //     if (selectedIndex === -1) {
    //         newSelected = newSelected.concat(selected, id);
    //     } else if (selectedIndex === 0) {
    //         newSelected = newSelected.concat(selected.slice(1));
    //     } else if (selectedIndex === selected.length - 1) {
    //         newSelected = newSelected.concat(selected.slice(0, -1));
    //     } else if (selectedIndex > 0) {
    //         newSelected = newSelected.concat(
    //             selected.slice(0, selectedIndex),
    //             selected.slice(selectedIndex + 1),
    //         );
    //     }

    //     this.setState({ selected: newSelected });
    // };

    handleDetailClick(event, alert){
        this.setState({selectedAlert: alert});
    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };
    handleAction = event => {
        this.setState({ details: this.state.details ? false : true });
        this.setState({ list: this.state.list == 6 ? 12 : 6 });
    };
    isSelected = id => this.state.selected.indexOf(id) !== -1;

    // handleUpdateDetail = (id) => {
    //     // console.log("clicked row with id " + id);
    //     this.setState({ updatedetailID: id, details:true });
    // };

    handleUpdateDetail = (id) => {
        console.log(id);
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
          newSelected = newSelected.concat([], id);
        } 

        this.setState({ selected: newSelected, updatedetailID: id, details:true });
    };

    _onChangeSearch = (e) =>{
        //console.log(e.target.value);
        if (e.target.value){
            console.log(e.target.value);
            console.log(this.state.data);
            var filtered = this.state.data.filter(function(itm){
                return itm.description.toLowerCase().includes(e.target.value.toLowerCase())
            });
        } else {
            var filtered = this.state.data
        }
        
        //console.log(filtered);
        this.setState({filtered: filtered})
    };

    render() {
        const { classes, theme } = this.props;
        const { data, order, orderBy, selected, rowsPerPage, page, anchor, open, details, list , filtered,detailSelected}  = this.state;
        const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);
        // console.log("passing update row with id " + this.state.updatedetailID);
        const detailsView = (<Grid item md={6} className={classes.contentWrapper}>
            <ListDetail username={this.props.username} queryID={this.state.updatedetailID}/>
        </Grid>);
        const searchBar = (<div style={{ padding: '4px', marginLeft :'8px'}}>
            <Grid container spacing={8} alignItems="flex-end">
                <Grid item>
                    <SearchIcon />
                </Grid>
                <Grid item>
                    <TextField id="input-with-icon-grid" label="Search..." fullWidth={true} onChange={this._onChangeSearch} value={this.state.inputValue}/>
                </Grid>
            </Grid>
            <Divider />
        </div>);

        const table_height = (this.state.height - 246) + "px";
        // console.log(table_height);
        // console.log("in tables")
        const style_height = {
            height: table_height,
        };

        return (
            <div className={classes.root}>
                <EnhancedTableToolbar type={this.state.typename} handleDetailViewToggle={this.handleDetailViewToggle} details={this.state.details}/>                
                <Grid container padding>
                    <Grid item md={this.state.details ? 6:12} className={classes.grid}>
                        <Card className={classes.tableWrapper} style={style_height}>       
                            <CustomizedTable
                                tableHeader={this.state.fields}
                                data={filtered}
                                searchBar={true}
                                clickEvent={(n)=>this.handleUpdateDetail(n.id)}
                            />              
                            <TablePagination
                                component="div"
                                count={data.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                backIconButtonProps={{
                                    'aria-label': 'Previous Page',
                                }}
                                nextIconButtonProps={{
                                    'aria-label': 'Next Page',
                                }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            /> 
                        </Card>                       
                    </Grid>
                    {this.state.details ? detailsView : null}
                </Grid>
                <Divider />
            </div>
        );
    }
}

VendorAlertTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(VendorAlertTable);


// WEBPACK FOOTER //
// ./src/components/Routines/RoutineDetailTable.js